import { DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { base64StringToBlob } from 'blob-util';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { saveAs } from 'file-saver';
import { PNoteService } from 'src/app/service/pnote.service';
import { AppService } from 'src/app/service/app.service';
import { config } from 'src/app/config/config';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
import { DatatableService } from 'src/app/service/datatable.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
declare var $: any;
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.css']
})
export class ViewReportComponent implements OnInit {

  entityCodeArray: any[];
  test: any[];
  monthArray: string[];
  yearArray: number[];
  statusArray: any[];
  config: any = config;
  reportForm: FormGroup;
  pNotesList: any[];
  pNoteToBeDeleted: String;
  addNewPNotes: boolean = false;
  userDetails: any;
  entityType: String;
  entityCode: String;
  // cutOffDayOfMonth: number = 13;//get from backend
  withinCutoffDate: boolean = false;
  bsValue: any;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  previousMonthRecord: any = {};
  showDataTable: boolean = true;

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private appService: AppService,
    private pNoteService: PNoteService,
    private fsService: ForexDerivativesService,
    private dataTableService: DatatableService  
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("ODI Submission")
    this.monthArray = Array.from({ length: 12 }, (_, i) => new Date(2000, i).toLocaleDateString('default', { month: 'short' }).toUpperCase());
    this.yearArray = Array.from({ length: new Date().getFullYear() - 2019 }, (_, index) => 2020 + index);
    this.statusArray = ['SUBMITTED', 'APPROVED'];//get from backend
    this.userDetails = this.userDetailsService.getUserDetails() || {};
    
    this.entityType = this.userDetails.entityType;
    this.entityCode = this.userDetails.entityCode;

    //to restrict member access to other client list
    if(this.entityType == 'MEMBER'){
      this.getAutoPopulatedUserValues('MEMBER');
    }
    else{
      this.getAutoPopulatedUserValues('NICCL');
    }
      
    const { month, year } = this.getPreviousMonthAndYear();
    this.reportForm = this.formBuilder.group({
      entityCode: [{ value: this.entityType == 'MEMBER' ? this.userDetails?.entityCode : null, disabled: this.entityType == 'MEMBER' ? true : null }],
      year: [year],
      month: [month],
      status: []
    });
    this.getSubmissionDueDate();
    this.getSubmittedPNotes();
  }

  get pf() { return this.reportForm.controls; }

  getAutoPopulatedUserValues(userType: String) {
    this.spinner.show();
    this.fsService.getCounterPartyListInterbank().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.entityCodeArray = [];
        if (error.statusCode != 200) {
          this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
        }
        return throwError(error.error)
      })
    ).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.entityCodeArray = userType == 'MEMBER' ? response.data.filter(ele => ele.entityCode == this.userDetails?.entityCode) : response.data;
      } else {
        this.entityCodeArray = [];
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })
  }

  getSubmissionDueDate() {
    this.pNoteService.getSubmissionDueDate().pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.withinCutoffDate = new Date().getDate() <= response.data ? true : false;
        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  getSubmittedPNotes() {

    this.showDataTable = false;
    let requestObject = {
      "entityCode": this.pf.entityCode?.value || null,
      "year": +this.pf.year?.value || 0,
      "month": this.pf.month?.value || null,
      "status": this.pf.status?.value || null
    }
    this.pNoteService.getSubmittedPNotes(requestObject).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.pNotesList = response.data;

        const { month, year } = this.getPreviousMonthAndYear();
        if (requestObject.month == month && requestObject.year == year) {
          if (this.pNotesList.filter(data => (data.month == month && data.year == year)).length > 0) {
            this.previousMonthRecord = this.pNotesList.filter(data => (data.month == month && data.year == year))[0];
            this.addNewPNotes = false;
          } else {
            this.addNewPNotes = true;
          }
        }
        this.dataTableService.setDatatable("pnotesList", 11, 10, [10, 25, 50, 100]);
        this.showDataTable = true;
        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  getPreviousMonthAndYear(): { month: String, year: number } {

    let todaysDate = new Date();
    const prevMonthDate = new Date(todaysDate);
    prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

    return {
      month: this.monthArray[prevMonthDate.getMonth()],   //subtracting 1 to get previous year, adding 1 to get human readable month
      year: prevMonthDate.getFullYear()
    };

  }

  showDeleteModal(pNotesID) {
    if (pNotesID != null) {
      this.pNoteToBeDeleted = pNotesID;
      $("#deleteModal").modal('show');
    }
  }

  deleteSubmission() {
    this.pNoteService.deleteAnnexure(this.pNoteToBeDeleted).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.getSubmittedPNotes();
        $('.selectpicker').selectpicker('refresh');
        this.router.navigate(['/securities/odi/uploadAnnexure'], { queryParams: { id: "newRequest" }, relativeTo: this.route, skipLocationChange: true });
      }
    })
  }

  deleteReSubmission() {
    this.pNoteService.deleteAnnexure(this.previousMonthRecord.pnotesID).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.getSubmittedPNotes();
        $('.selectpicker').selectpicker('refresh');
        this.router.navigate(['/securities/odi/uploadAnnexure'], { queryParams: { id: "newRequest" }, relativeTo: this.route, skipLocationChange: true });
      }
    })

  }

  openExistingSubmission(pNotesID) {
    this.router.navigate(['/securities/odi/uploadAnnexure'], { queryParams: { id: pNotesID }, relativeTo: this.route, skipLocationChange: true });
  }

  reset() {
    const { month, year } = this.getPreviousMonthAndYear();
    this.reportForm.patchValue({
      entityCode: this.entityType == 'MEMBER' ? this.userDetails?.entityCode : null,
      month: month,
      year: year,
      status: null
    });

    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  newRequestSubmission() {
    if (this.addNewPNotes && this.withinCutoffDate) {
      this.router.navigate(['/securities/odi/uploadAnnexure'], { queryParams: { id: "newRequest" }, relativeTo: this.route, skipLocationChange: true });
    } else if (!this.withinCutoffDate) {
      this.toastr.warning("You have exceeded cutoff date for ODI submission")
    } else if (!this.addNewPNotes) {
      $("#deleteResubmitModal").modal("show");
    }
  }

  downloadPnoteAnnexureById(reqId, filename) {
    this.pNoteService.downloadPnoteAnnexureById(reqId).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        let file = response.data;
        let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        let blob = base64StringToBlob(file, contentType);
        saveAs(blob, filename, { autoBOM: true });
      } else {
        this.toastr.error(response.message);
      }
    })
  }

  clearSearch() {
    this.dataTableService.setDatatable("pnotesList", 11, 10, [10, 25, 50, 100]);
  }

}
